module.exports = __webpack_public_path__ + "static/media/optioPay_header_image.292bd410.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/optioPay_header_image.png
// module id = 464
// module chunks = 21